import type { StringIndexable } from "@/types/object";

type CleanOptions = {
  jsonStringifyArrays?: boolean;
  removeUndefined?: boolean;
}

const clean = <T = any>(obj: any, remove: any[] = [undefined, null], options: CleanOptions = {}): T  => {
  const next: any = {};
  for (const [key, value] of Object.entries(obj)) {
    if (options.removeUndefined) {
      if (typeof value === 'undefined' || value === 'undefined') continue;
    }
    if (remove.includes(value)) continue;
    if (Array.isArray(value)) {
      if (options.jsonStringifyArrays) {
        next[key] = JSON.stringify(value);
        continue;
      }
      next[key] = value.filter(it => remove.includes(it) === false).map(it => typeof it === 'object' ? clean(it, remove) : it);
      continue;
    }
    if (typeof value === 'object') {
      next[key] = clean(value, remove);
      continue;
    }
    
    next[key] = value;
  }

  return next as T;
}

export const urlEncode = (obj: StringIndexable, shouldClean: boolean = true, options: CleanOptions = {}): string => {
  return new URLSearchParams(shouldClean ? clean(obj, [], options) : obj).toString();
}
